import { ActionIcon, Tooltip } from '@mantine/core';
import { useClickOutside } from '@mantine/hooks';
import { IconInfoCircle } from '@tabler/icons-react';
import '../../styles/infoLabel.css';
import { type ReactNode, useState } from 'react';
import { isString } from '../../utils/utilFunctions';

export const LabelNode = ({
    label,
    labelInfo,
    alwaysShowInfo,
}: {
    label: ReactNode;
    labelInfo: ReactNode;
    alwaysShowInfo?: boolean;
}) => {
    const [open, setOpen] = useState(false);
    const ref = useClickOutside(() => setOpen(false));

    if (!labelInfo) {
        if (!isString(label)) {
            return label;
        }

        return (
            <div
                className={'label-node'}
                style={{
                    display: 'inline-flex',
                    maxWidth: '100%',
                    alignItems: 'center',
                    width: 'inherit',
                }}
            >
                <div className={'label-ellipsis'}>{label}</div>
            </div>
        );
    }

    return (
        <Tooltip
            ref={ref}
            opened={open}
            label={labelInfo}
            position={'bottom-start'}
            maw={500}
            zIndex={9001}
        >
            <div
                className={'label-node'}
                style={{
                    display: 'inline-flex',
                    maxWidth: '100%',
                    alignItems: 'center',
                    width: 'inherit',
                }}
            >
                <div className={'label-ellipsis'}>{label}</div>
                <div
                    className={!alwaysShowInfo ? 'hidden-child' : undefined}
                    style={{ paddingLeft: 4, maxHeight: 18 }}
                >
                    <ActionIcon
                        p={0}
                        c={'inherit'}
                        size={18}
                        variant={'transparent'}
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen(true);
                        }}
                    >
                        <IconInfoCircle size={18} />
                    </ActionIcon>
                </div>
            </div>
        </Tooltip>
    );
};
